<template>
    <div class="reg-cnt">
        <!-- <div class="haslogged" v-if="hasAccount"></div> -->
        <div class="reg-input">
            <div class="haslogged" v-if="hasAccount"></div>

            <div>
                <div class="choose" v-if="!isEventPageLogin">
                    <div class="d-flex align-items-center justify-content-center ">
                        <div v-for="(item, index) in list" :key="index"
                            class="d-flex justify-content-center align-items-center mr-24 cursor"
                            @click="handlePlatform(item)">
                            <div :class="platform === item.id ? 'r-active-img' : 'r-img'"></div>
                            <img :src="item.icon" class="pl-12 icon-img" />
                        </div>
                    </div>
                </div>
                <div class="phone-item d-flex align-items-center">
                    <div class="input-bg position-relative">
                        <div class="input-code"></div>
                        <input type="text" class="inpuy-style" autocomplete="off" :placeholder="phonePlaceholder"
                            v-model="account" maxlength="8" oninput="value=value.replace(/[^\d]/g,'')" />
                    </div>
                    <div class="btn ml-12 cursor" v-if="timeTrue" @click="handleGetCode"></div>
                    <!-- <div class="acquireAgain ml-12 cursor" v-else @click="acquire">재전송({{ time }}s)</div> -->
                    <div v-else>
                        <div v-if="time > 0" class="acquireAgain ml-12 cursor gray-bg">재전송({{ time }})초</div>
                        <div v-else class="acquireAgain ml-12 cursor" @click="acquire">재전송({{ time }})초</div>

                    </div>
                </div>
                <div class="code-item d-flex align-items-center mt-8">
                    <div class="input-bg position-relative">
                        <input type="text" class="inpuy-style" maxlength="6" autocomplete="off" placeholder="인증번호 입력"
                            v-model="captchaVal" oninput="value=value.replace(/[^\d]/g,'')" />
                    </div>
                    <div class="btn ml-12 cursor" @click="handleSubscribe"></div>
                </div>
            </div>
        </div>
        <!-- checbox-1 -->
        <div class="checkbox-position">
            <div class="haslogged-checkbox" v-if="hasAccount"></div>
            <div class=" position-relative mt-24 c-h cursor" @click="handlePolicyA">

                <div class="c-active-img" v-if="policyA"></div>
                <div class="c-img" v-else></div>
                <div class="c-1   c-text"></div>
            </div>
        </div>

        <!-- checbox-2 -->
       
        <div class="d-flex w100 align-items-center justify-content-between mt-12">
            <div class="checkbox-position">
            <div class="haslogged-checkbox" v-if="hasAccount"></div>
            <div class=" position-relative c-h cursor" @click="handlePolicyB">
                <div class="c-active-img" v-if="policyB"></div>
                <div class="c-img" v-else></div>
                <div class="c-2   c-text"></div>
            </div>
            </div>
            
            <a href="https://privacypolicy-kr.ujoygames.co.kr/" target="_blank">
                <div class="btn-more cursor"></div>
            </a>

        </div>
        <!-- checbox-3 -->
        <div class="d-flex w100 align-items-center justify-content-between mt-12">
            <div class="checkbox-position">
            <div class="haslogged-checkbox" v-if="hasAccount"></div>
            <div class=" position-relative c-h cursor" @click="handlePolicyC">
                <div class="c-active-img" v-if="policyC"></div>
                <div class="c-img" v-else></div>
                <div class="c-3   c-text"></div>
            </div>
            </div>
           
            <a href="https://useragreement-kr.ujoygames.co.kr/" target="_blank">
                <div class="btn-more cursor"></div>
            </a>

        </div>
        <!-- 错误信息 -->
        <div class="err-txt">{{ errTxt }}</div>
        <!-- end -->
        <div class="btn-list d-flex  align-items-center justify-content-center cursor" v-if="!isEventPageLogin">
            <div class="google btn-size mr-8" @click="GP_reg('gp')"></div>
            <div class="ios btn-size mr-8" @click="AS_reg('as')"></div>
            <div class="onestore btn-size" @click="OS_reg('os')"></div>
            <!--暂时不能点击- @click="OS_reg('os')" -->

        </div>
    </div>
</template>
<script>

export default {
    props: ["onNext", 'isEventPageLogin', 'box2Login'],

    created() {
        if (localStorage.getItem('zero9_account') ||  this.hasAccount) {
            this.hasAccount = true
        } else {
            this.hasAccount = false
        }
    },
    mounted() {
    },
    watch:{
        box2Login(newVal, oldVal) {
            this.hasAccount = newVal

        },
       
    },
    data() {
        return {
            hasAccount: false,
            errTxt: '',
            // isEventPageLogin: false,
            platform: 0, // 注册平台
            captchaVal: '', // 验证码
            timeTrue: true,
            time: 0,
            policyA: false, //条款A
            policyB: false, //条款B
            policyC: false, //条款C
            phonePlaceholder: '- 휴대폰 번호를 입력해주세요', // 输入手机号
            codePlaceholder: '인증번호', // 获取验证码
            account: '',
            // 预约按钮
            list: [

                {
                    value: "android",
                    isCheck: true,
                    id: 0,
                    icon: require("../../assets/img/common/login/android.png"),
                },
                {
                    value: "ios",
                    isCheck: false,
                    id: 1,
                    icon: require("../../assets/img/common/login/ios.png"),
                },
            ],

        };
    },

    methods: {
        // 点击ios， andriod
        handlePlatform(item) {
            this.platform = item.id;
        },
        // 点击隐私条款
        handlePolicyA() {
            this.policyA = !this.policyA
            if (this.policyA) {
                this.policyB = true
                this.policyC = true
            } else {
                this.policyB = false
                this.policyC = false
            }
        },
        handlePolicyB() {
            this.policyB = !this.policyB
            if (!this.policyB) {
                this.policyA = false
            } else if (this.policyB && this.policyC) {
                this.policyA = true
            }
        },
        handlePolicyC() {
            this.policyC = !this.policyC
            if (!this.policyC) {
                this.policyA = false
            } else if (this.policyB && this.policyC) {
                this.policyA = true
            }
        },
        // 验证码接口
        handleSms() {
            // 获取验证码接口
            const account = this.account.replace(/-/g, '')
            const reqTime = Math.floor(new Date().getTime() / 1000);
            // 计算signature
            const params = {
                code: 82,
                mobile: '010' + account,
                game: 421,
            };

            this.$axios({
                method: "post",
                url: "sms",
                data: {
                    signature: this.common.makeSignature(params, reqTime),
                    reqTime: reqTime,
                    code: 82,
                    mobile: '010' + account,
                    game: 421,
                },
                //withCredentials:true, //局部携带cookie
                headers: {}, //如果需要添加请求头可在这写
            })
                .then((res) => {
                    if (res.data.code === 0) { } else {
                        this.common.getErrCode(res.data.code)
                        this.errTxt = window.ERR_TEXT
                    }

                })
                .catch((err) => { });
        },
        // 倒计时
        acquire() {
            this.timeTrue = false;
            this.time = 60;
            var setTimeoutS = setInterval(() => {
                this.time--;
                if (this.time <= 0) {
                    clearInterval(setTimeoutS);
                    this.timeTrue = true;
                }
            }, 1000);
        },
        // 点击获取验证码
        handleGetCode() {
            // 此时禁止轮播图滑动
            this.$emit("handleEVent", false);
            const account = this.account.replace(/-/g, '')

            if (account.toString().length !== 8 || isNaN(Number(account))) {
                this.errTxt = '올바른 번호를 입력해 주세요'
                this.account = "";
            } else {
                this.errTxt = ''

                this.acquire()
                this.handleSms()
                // this.captchaFlag = true

            }

        },

        // 预注册接口
        handleSubscribe() {

            const account = this.account.replace(/-/g, '')

            const reqTime = Math.floor(new Date().getTime() / 1000);
            let source = 'unknow';
            let target = 'unknow';
            let share = "unknow"
            let url = window.location.search

            let shareParam = url.indexOf("share") >= 0 ? this.common.getUrlParam("share").slice(0, -2) : this.common.getUrlParam("share")

            source = this.common.getUrlParam("source") || "unknow";
            target = this.common.getUrlParam("target") || "unknow";
            share = shareParam || "unknow";
            // 计算signature
            const params = {
                account: '010' + account,
                game: 421,
                type: 0
            };

            if (account.toString().length !== 8 || isNaN(Number(account))) {
                this.errTxt = '올바른 번호를 입력해 주세요.'
                this.account = "";
            } else if (this.captchaVal.toString().length !== 6) {
                this.errTxt = '인증번호를 잘못 입력했습니다.'
            } else if (!this.policyA || !this.policyB || !this.policyC) {
                this.errTxt = '이용약관을 동의해 주세요.'
            } else {

                this.$axios({
                    method: "post",
                    url: "qyhx/subscribe",
                    data: {
                        signature: this.common.makeSignature(params, reqTime),
                        reqTime: reqTime,
                        account: '010' + account,
                        game: 421,
                        type: 0,
                        platform: this.platform,
                        code: 82,
                        captcha: this.captchaVal,
                        source: source,
                        target: target,
                        share: share
                    },
                    //withCredentials:true, //局部携带cookie
                    headers: {}, //如果需要添加请求头可在这写
                })
                    .then((res) => {
                        if (res.data.code === 0) {

                            localStorage.setItem("zero9_uuid", res.data.data.uuid);
                            localStorage.setItem("zero9_isNew", res.data.data.isNew);
                            localStorage.setItem("zero9_account", account);

                            this.errTxt = ''
                            this.account = ''
                            this.captchaVal = ''
                            this.policyA = false
                            this.policyB = false
                            this.policyC = false

                            this.hasAccount = true
                            this.$emit('handleInfoAgain', res.data.data.isNew)
                            // this.$forceUpdate()

                            if (res.data.data.isNew === 1) gtag('event', 'complete_reg2');
                        } else {

                            // this.errTxt = '이미 등록된 번호입니다.'
                            this.hasAccount = false
                            this.common.getErrCode(res.data.code)
                            this.errTxt = window.ERR_TEXT
                        }

                    })
                    .catch((err) => { });
            }
        },

        // btn 跳转
        GP_reg(val) {
            this.common.goShare(val)
        },
        AS_reg(val) {
            this.common.goShare(val)
        },
        OS_reg(val) {
            this.common.goShare(val)
        },
    },
};
</script>
<style lang="scss" scoped>
.haslogged {
    background-color: #00000082;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
}

.reg-cnt {
    width: 513px;
    margin: 0 auto;
    padding-top: 30px;
    position: relative;

    .reg-input {
        height: 110px;
        position: relative;

        .haslogged {
            background-color: #0000003f !important;
            width: 100%;
            height: 100%;
            z-index: 9;
            position: absolute;
            top: 0;
        }
    }

    .checkbox-position {
        position: relative;
    }

    .haslogged-checkbox {
        background-color: #0000003f !important;
        width: 100%;
        height: 100%;
        z-index: 9;
        position: absolute;
        top: 0;
    }
    .err-txt {
        color: #d81028;
        font-size: 18px;
        font-weight: bold;
    }

    .c-h {
        height: 25px;
        // width: 238px;
        display: flex;
        align-items: center;

        .c-img {
            width: 23px;
            height: 23px;
            background: url("../../assets/img/common/checkbox.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .c-active-img {
            width: 23px;
            height: 23px;
            background: url("../../assets/img/common/checkbox-active.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .c-text {
            margin-left: 8px;
        }
    }

    .choose {
        margin-bottom: 20px;

        .r-img {
            width: 30px;
            height: 30px;
            background: url("../../assets/img/common/login/radio.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .r-active-img {
            width: 30px;
            height: 30px;
            background: url("../../assets/img/common/login/radio-active.png") no-repeat center top;
            background-size: 100% 100%;
        }
    }

    .btn-list {
        margin-top: 16px;

        .btn-size {
            width: 158px;
            height: 46px;
        }

        .google {
            background: url("../../assets/img/common/login/button-google.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .ios {
            background: url("../../assets/img/common/login/button-apple.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .onestore {
            background: url("../../assets/img/common/login/button-one.png") no-repeat center top;
            background-size: 100% 100%;
            // filter: grayscale(100%);
        }
    }

    .input-bg {
        background: url("../../assets/img/common/login/phone-type.png") no-repeat center top;
        background-size: 100% 100%;
        width: 327px;
        height: 45px;

        .input-code {
            background: url("../../assets/img/common/login/code.png") no-repeat center top;
            background-size: 100% 100%;
            width: 36px;
            height: 29px;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            left: 12px;
        }

        .inpuy-style {
            // margin-top: -40px;
            position: absolute;
            padding-left: 31px;
        }

        input[type="text"] {
            display: inline-block;
            font-size: 16px;
            font-family: KozMinStd-Bold;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 2px;
            color: #a3a9af;
            background: transparent;
            width: 327px;
            height: 45px;
            line-height: 43px;
            text-align: center;
        }

        input::placeholder {
            color: #a3a9af;
        }

    }

    .phone-item {
        .btn {
            background: url("../../assets/img/common/login/btn-1.png") no-repeat center top;
            background-size: 100% 100%;
            width: 177px;
            height: 45px;
        }

        .acquireAgain {
            width: 177px;
            height: 45px;
            line-height: 45px;
            font-weight: bold;
            background-color: #d81028;
            color: #fff;
            text-align: center;
        }

        .gray-bg {
            background-color: rgba(128, 128, 128, 0.61);
        }
    }

    .code-item {
        .btn {
            background: url("../../assets/img/common/login/btn-2.png") no-repeat center top;
            background-size: 100% 100%;
            width: 177px;
            height: 45px;
        }
    }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .reg-cnt {
        width: 480px !important;
        padding-top: 25px !important;
    }

    .btn-size {
        width: 134px !important;
        height: 39px !important;
    }

    .input-bg {
        width: 278px !important;
        height: 38px !important;

        input[type="text"] {
            width: 278px !important;
            height: 38px !important;
            font-size: 14px !important;

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/regLogin.vue